import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV5.value;

export const sliderConfig = newCollectionTemplate({
  typeFields: {
    title: "text",
    description: "textarea",
    link: "text", // check this solution
    image: "image",
    alt: "text",
    setId: "",
    setType: "",
    setTitle: "",
    isShow: "boolean",
  },
  itemTemplate: {
    title: "",
    description: "",
    link: "",
    image: "",
    alt: "",
    setId: "",
    setType: "",
    setTitle: "",
    isShow: true,
  },
  type: typeSlider,
  showAsTitle: "title", // only texts fields
  allowUseSets: true,
});

// export const sliderConfig1 = {
//   typeFields: {
//     title: "text",
//     description: "textarea",
//     link: "text", // check this solution
//     image: "image",
//     alt: "text",
//     setId: "",
//     setType: "",
//     setTitle: "",
//   },
//   itemTemplate: {
//     title: "",
//     description: "",
//     link: "",
//     image: "",
//     alt: "",
//     setId: "",
//     setType: "",
//     setTitle: "",
//   },
//   type: typeSlider,
//   showAsTitle: "title", // only texts fields
//   allowUseSets: true,
// };

export const initBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [
        {
          isShow: true,
          setId: null,
          setType: "",
          setTitle: "",
          title: "Summer is here!",
          description:
            "Travel to the Baltic States and Warsaw. Tickets from 9 €",
          alt: "Aistė's review about Lux Express",
          link: "",
          image:
            "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/slide1.png",
        },
        {
          isShow: true,
          setId: null,
          setType: "",
          setTitle: "",
          title: "Winter is here!",
          description:
            "Travel to the Baltic States and Warsaw. Tickets from 9 €",
          alt: "Aistė's review about Lux Express",
          link: "",
          image:
            "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/slide2.png",
        },
        {
          isShow: true,
          setId: null,
          setType: "",
          setTitle: "",
          title: "Spring is here!",
          description:
            "Travel to the Baltic States and Warsaw. Tickets from 9 €",
          alt: "Aistė's review about Lux Express",
          link: "",
          image:
            "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/slide1.png",
        },
        {
          isShow: true,
          setId: null,
          setType: "",
          setTitle: "",
          title: "Autumn is here!",
          description:
            "Travel to the Baltic States and Warsaw. Tickets from 9 €",
          alt: "Aistė's review about Lux Express",
          link: "",
          image:
            "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/slide2.png",
        },
      ],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
